/** Small diamond brand glyph used in logos and certificate headers. */
export function BrandMark({ className = 'text-[17px]' }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="currentColor" aria-hidden>
      <path d="M12 2 22 12 12 22 2 12Z" />
    </svg>
  );
}
